import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import CheckboxExcluded from "./CheckboxExcluded";
import { Colors } from "@flow/style";
import Tooltip from "./Tooltip";
import CheckboxRequired from "./CheckboxRequired";

const OptionsRow = ({ isActive, selected, option, onSelect }) => {
  const {
    isRequired,
    isExcluded
  } = option

  return (
    <Row isActive={isActive}>
      <CheckboxRequired
        disabled={selected && isExcluded}
        isActive={isActive}
        checked={selected && isRequired}
        option={option}
        onClick={onSelect}
      />
      <CheckboxExcluded
        disabled={selected && isRequired}
        isActive={isActive}
        checked={selected && isExcluded}
        option={option}
        onClick={onSelect}
      />
      <OptionsName isActive={isActive}>{option.optionName}</OptionsName>
      <Tooltip text={option.attributes} />
      <Price>{option.price || option.retailPrice902 || 0} kr</Price>
    </Row>
  );
};

OptionsRow.propTypes = {
  isActive: PropTypes.bool,
  selected: PropTypes.bool,
  id: PropTypes.number,
  name: PropTypes.string,
  price: PropTypes.number,
  basePrice: PropTypes.number,
  excludes: PropTypes.array,
  requires: PropTypes.array,
  onClick: PropTypes.func
};

OptionsRow.defaultProps = {
  isActive: false,
  selected: false,
  id: 0,
  name: "",
  price: 0,
  basePrice: 0,
  excludes: [],
  requires: [],
  onClick: null
};

export default OptionsRow;

export const Row = styled.div`
  display: flex;
  margin: 0 10;
  border-bottom: 1px solid #e4e2e2;
  padding: 10px 0 10px 0;
  line-height: 22px;
  font-size: 14px;
  cursor: ${props => (props.isActive ? "pointer" : "not-allowed")};
  display: grid;
  grid-template-columns: 100px 100px auto 50px 80px;
`;

export const OptionsName = styled.div`
  padding-right: 15px;
  text-align: left;
  text-transform: capitalize;
  color: ${props => (props.isActive ? Colors.Grey1 : Colors.Grey3)};
  width: 460px;
`;

export const Price = styled.div`
  flex-grow: 2;
  text-align: right;
`;
